import type { settings as en } from '@/i18n/locales/en/settings';
import type { Translation } from '@/i18n/types';

export const settings: Translation<typeof en> = {
  title: 'Definições',
  lead: 'O perfil da sua empresa, a identidade visual e as definições de privacidade.',
  noCompany: 'Nenhuma empresa ativa selecionada.',
  adminOnly: 'Só um administrador da plataforma pode alterar isto — pode ver os valores atuais.',
  save: 'Guardar',
  nav: {
    label: 'Menu de definições',
    profile: 'Perfil',
    branding: 'Identidade visual',
    privacy: 'Privacidade',
    modules: 'Módulos',
  },
  profile: {
    title: 'Perfil',
    name: 'Nome da organização',
    industry: 'Setor',
    industryHint: 'Texto livre, p. ex. "Logística" ou "Saúde".',
    employeeCount: 'Número de funcionários',
    plan: 'Plano',
    planPlaceholder: 'Ver Subscrição',
  },
  branding: {
    title: 'Identidade visual',
    lead: 'O seu logótipo e cor de destaque, com pré-visualização em direto.',
    logo: 'Carregar logótipo',
    logoHint: 'É carregado de imediato; ou preencha um URL existente abaixo.',
    logoUrl: 'URL do logótipo',
    upload: {
      uploading: 'A carregar…',
      tooLarge: 'O ficheiro é demasiado grande (máx. 10MB).',
      invalidType: 'Tipo de ficheiro não permitido.',
    },
    accentColor: 'Cor de destaque',
    preview: 'Pré-visualização em direto',
    colors: {
      mint: 'Menta',
      pine: 'Pinho',
      ink: 'Tinta',
      amber: 'Âmbar',
      coral: 'Coral',
      sky: 'Céu',
    },
  },
  privacy: {
    title: 'Privacidade',
    lead: 'O tamanho mínimo do grupo para estatísticas agregadas e o que a sua empresa partilha.',
    minGroupSize: 'Tamanho mínimo do grupo (k-anonimato)',
    minGroupSizeHint:
      'Abaixo disto, um grupo é demasiado pequeno para mostrar estatísticas agregadas.',
    minGroupSizeValue: '{{count}} pessoas',
    effective: 'Atualmente em vigor: {{count}} pessoas',
    aggregatedData: 'Dados agregados',
    aggregatedDataHint: 'Mostrar estatísticas agregadas para grupos que atinjam o tamanho mínimo.',
    explicitConsent: 'Consentimento explícito necessário',
    explicitConsentHint:
      'Exigir uma resposta de consentimento individual em vez de consentimento coletivo.',
    dataExport: 'Exportação de dados',
    dataExportHint: 'Permitir a exportação de dados estatísticos.',
    auditLogHint: 'As ações administrativas são sempre registadas num registo de auditoria.',
  },
  modules: {
    title: 'Módulos',
    lead: 'Ative ou desative os módulos disponíveis para a sua empresa.',
    vitality: 'Vitalidade',
    vitalityHint: 'Monitorização do sono, stress, frequência cardíaca e atividade.',
    participation: 'Participação',
    participationHint: 'Funil de participação e métricas de engajamento.',
    pilots: 'Pilotos',
    pilotsHint: 'Execute e acompanhe os programas piloto.',
    challenges: 'Desafios',
    challengesHint: 'Crie e gerencie desafios de bem-estar.',
    communication: 'Comunicação',
    communicationHint: 'Envie notificações e mensagens aos funcionários.',
    documents: 'Documentos',
    documentsHint: 'Publique e gerencie documentos da empresa.',
    reports: 'Relatórios',
    reportsHint: 'Gere e exporte relatórios analíticos.',
    ai_coach: 'Treinador de IA',
    ai_coachHint: 'Treinamento personalizado com inteligência artificial.',
  },
};
